import {
  RecentChatMessagesQuery,
  RecentChatMessageSortEnum,
  RecentChatMessagesQueryVariables,
  useworkspaceAuthMeV2Query,
} from '@/types/generated/graphql';
import { CURSOR_RECENT_CHAT_MESSAGES } from '@/graphql/cursor.graphql';
import { RecentChatMembersFilter } from '@modules/members/members.types';
import { toSidebarRows } from '@modules/members/utils/to-sidebar-rows';
import { cacheOnly } from '@shared/constants';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { useMemo, useState } from 'react';

const SUBMENU_PAGE_SIZE = 15;

export function useSubmenuMembersList() {
  const [filter, setFilter] = useState<RecentChatMembersFilter>({
    query: '',
    role: null,
    teams: null,
    sortBy: RecentChatMessageSortEnum.lastMessage,
  });

  const recent = useCursorPagination<RecentChatMessagesQuery, RecentChatMessagesQueryVariables>({
    schema: CURSOR_RECENT_CHAT_MESSAGES,
    responseDataKey: 'recentChatMessages',
    variables: {
      limit: SUBMENU_PAGE_SIZE,
      query: filter.query || null,
      role: filter.role,
      teams: filter.teams?.length ? filter.teams : null,
      sortBy: filter.sortBy,
    },
    // The overlay unmounts when closed, so the message subscription's refetch misses it; revalidate on reopen.
    options: { fetchPolicy: 'cache-and-network' },
  });

  const { data: workspaceAuthMe } = useworkspaceAuthMeV2Query(cacheOnly);
  const selfWorkspaceMemberId = workspaceAuthMe?.workspaceAuthMeV2?.data?.currentUserWorkspace?.id;

  const rows = recent.data?.data;
  const { members, allMembers } = useMemo(
    () => toSidebarRows(rows, selfWorkspaceMemberId),
    [rows, selfWorkspaceMemberId]
  );

  function handleSortMember(sortBy: RecentChatMessageSortEnum) {
    setFilter((prev) => ({ ...prev, sortBy: sortBy }));
  }

  return {
    data: { data: members },
    allMembers: filter.query ? undefined : allMembers,
    filter,
    setFilter,
    handleSortMember,
    loading: recent.loading,
    initialLoading: recent.initialLoading,
    hasNextPage: recent.hasNextPage,
    loadNextRef: recent.loadNextRef,
  };
}
